// @ts-ignore
import * as Sentry from '@sentry/browser';
let instance: Logger | null = null;


export class Logger {
  constructor() {
    // console.clear();
  }

  /**
   * Get Logger Instance, Creates one if none exists
   * @return {Logger} Logger Instance
   */
  static get i() {
    if (!instance) {
      instance = new Logger();
    }
    return instance;
  }

  info(...message: string[]) {
    const label = 'adaptive-ui';
    console.info('%c '+(label?'['+label+']':'')+' ', 'background: #222; color: #fff', ...message);
  }

  // error
  error(...message: any[]) {
    const label = 'adaptive-ui';
    console.error('%c '+(label?'['+label+']':'')+' ', 'background: #222; color: #fff', ...message);
  }

  // todo warn
  warn(...message: string[]) {
    const label = 'adaptive-ui';
     console.warn('%c '+(label?'['+label+']':'')+' ', 'background: #222; color: #fff', ...message);
  }

  // debug(...message: any[]) {
  //   if (window.process['env']['NODE_ENV'] === 'development') {
  //     // console.debug(...message);
  //   }
  // }

  alert(...message: any[]) {
    Sentry.captureException(new Error(message.join(' ')));
  }

  incompleteDev(...message: string[]) {
    this.warn('[INCOMPLETE DEV]', ...message);
  }

  deprecated(...message: any[]) {
    this.warn('[DEPRECATED API USAGE] ', ...message);
  }

  switchConfiguration(...message: (string | this)[]) {
    // use warning
    this.info('[SWITCH CONFIGURATION]', ...message.map(String));
  }
}

